import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

interface CompanyRouteProps {
  children: React.ReactNode;
  allowedCompanies?: string[];
}

/**
 * 限制有管理權限的使用者才能訪問的路由
 * 會等待 AuthContext 載入完成後再判斷權限
 */
const CompanyRoute: React.FC<CompanyRouteProps> = ({
  children,
  allowedCompanies: _allowedCompanies,
}) => {
  const { loading, isAuthenticated, user } = useAuth();

  // 載入中顯示 loading
  if (loading) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
        }}
      >
        <div
          style={{
            background: 'rgba(255, 255, 255, 0.9)',
            padding: '2rem',
            borderRadius: '1rem',
            textAlign: 'center',
          }}
        >
          <div
            style={{
              display: 'inline-block',
              width: '40px',
              height: '40px',
              border: '4px solid #f3f3f3',
              borderTop: '4px solid #1E88A8',
              borderRadius: '50%',
              animation: 'spin 1s linear infinite',
              marginBottom: '1rem',
            }}
          />
          <p>載入中...</p>
        </div>
        <style>
          {`
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
          `}
        </style>
      </div>
    );
  }

  // 未登入導向登入頁
  if (!isAuthenticated) {
    return <Navigate to='/login' replace />;
  }

  // 平台管理員直接放行
  if (user?.is_superadmin) return <>{children}</>;

  // 有管理權限的使用者（Admin 角色或 can_manage_users 授權）才能訪問
  const hasAccess =
    user?.roles?.includes('ADMIN') ||
    user?.roles?.includes('SUPER_ADMIN') ||
    user?.permissions?.can_manage_users ||
    user?.is_department_manager;
  if (!hasAccess) {
    return <Navigate to='/' replace />;
  }

  return <>{children}</>;
};

export default CompanyRoute;
